/**
 * Autorisation d'un compte API pour un path
 *
 * @author Laurent Convert
 * @date 26/11/2025
 */
export class CompteApiAutorisation {
	/** Identifiant du compte API */
	idCompteAuth: number;

	/** Autorisation GET */
	get: boolean;

	/** Autorisation POST */
	post: boolean;

	/** Autorisation PUT */
	put: boolean;

	/** Autorisation PATCH */
	patch: boolean;

	/** Autorisation DELETE */
	delete: boolean;

	/** Path du endpoint */
	path: string;

	/**
	 * Constructeur
	 *
	 * @param dto DTO contenant les données
	 */
	constructor(dto?: CompteApiAutorisation) {
		if (dto) {
			Object.assign(this,dto);
		}
	}

	/**
	 * Met à jour l'autorisation pour une méthode HTTP
	 *
	 * @param method Méthode HTTP
	 * @param value Vrai ou faux
	 */
	setAutorisation(method: string, value: boolean) {
		switch (method.toUpperCase()) {
			case 'GET':
				this.get = value;
				break;
			case 'POST':
				this.post = value;
				break;
			case 'PUT':
				this.put = value;
				break;
			case 'PATCH':
				this.patch = value;
				break;
			case 'DELETE':
				this.delete = value;
				break;
		}
	}

	/**
	 * Vérifie si une autorisation est activée pour une méthode HTTP
	 *
	 * @param method Méthode HTTP
	 * @returns Vrai ou faux
	 */
	hasAutorisation(method: string): boolean {
		switch (method.toUpperCase()) {
			case 'GET':
				return this.get;
			case 'POST':
				return this.post;
			case 'PUT':
				return this.put;
			case 'PATCH':
				return this.patch;
			case 'DELETE':
				return this.delete;
		}
	}
}